import { type JSX } from 'react';
import { Spinner } from '@doxyme/ui/components/foundations';

export const FullPageSpinner = (): JSX.Element => (
  <div
    css={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    <Spinner disableShrink={false} mode='green' size={40} />
  </div>
);
